<form class="filters-form mb-4">
  <label class="form-control mb-0 flex-1">
    <div class="position-relative">
      <input
        type="search"
        name="main_pages_search"
        class="pr-5"
        [formControl]="searchControl"
        [placeholder]="'SEARCH' | translate"
        spellcheck="false"
      />

      <button
        type="button"
        class="postfix icon-button"
        attr.aria-label="{{ 'SEARCH' | translate }}"
      >
        <div [inlineSVG]="'assets/img/icons/search-icon-4.svg'"></div>
      </button>
    </div>
  </label>

  <div class="ml-auto">
    <div class="position-relative" container="body" dropdown>
      <button
        id="button-basic"
        dropdownToggle
        type="button"
        class="filter-button dropdown-toggle dropdown-filter"
        aria-controls="dropdown-basic"
        [tooltip]="'BATCH_MAILING.BLANKS_TAB.FILTER' | translate"
      >
        <span
          class="filter-button-icon"
          [inlineSVG]="'assets/img/icons/filter.svg'"
        ></span>
        <span>{{ 'BATCH_MAILING.BLANKS_TAB.FILTER' | translate }}</span>
      </button>
      <ul
        id="dropdown-basic"
        *dropdownMenu
        class="dropdown-menu"
        role="menu"
        aria-labelledby="button-basic"
      >
        @for (status of BLANK_STATUS_FILTERS; track status) {
          <li role="menuitem" (click)="changeStatus(status.value)">
            <button
              type="button"
              [class.mr-3]="queryParamMap.get('status') === status.value"
              [class.active]="queryParamMap.get('status') === status.value"
              class="dropdown-item"
            >
              {{ status.label | translate }}
            </button>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="ml-auto">
    <button
      class="filter-button red"
      type="button"
      [disabled]="!selected?.length"
      [tooltip]="
        (!selected?.length
          ? 'BATCH_MAILING.BLANKS_TAB.ACTIONS.SELECT_TO_DELETE'
          : 'DELETE'
        ) | translate
      "
      triggers="pointerenter:pointerout"
      (click)="remove()"
    >
      <fa-icon class="filter-button-icon red" [icon]="faTrashAlt"></fa-icon>
      <span class="red">{{ 'DELETE' | translate }}</span>
    </button>
  </div>
</form>
